import React from 'react';
import {
  AccordionsItem,
  AccordionsItemHeader,
  AccordionsItemSection,
  Gutter,
  ReadonlyTextarea,
  SmallHeader,
} from '@axiom/ui';
import type { UseOnboardingTextReturn } from '@axiom/ui';

import type { Nullable } from '../../types/utility.types';

export type EngagementDetailsLegalResourcesProps = {
  name?: string;
  texts: {
    resourcesText: Nullable<
      Pick<
        NonNullable<ReturnType<UseOnboardingTextReturn['getOnboardingTexts']>>,
        'resources'
      >
    >['resources'];
  };
};

export const EngagementDetailsLegalResources = ({
  name,
  texts,
}: EngagementDetailsLegalResourcesProps) => {
  return (
    <AccordionsItem name={name}>
      <AccordionsItemHeader>
        <SmallHeader>Legal Resources</SmallHeader>
      </AccordionsItemHeader>
      <AccordionsItemSection>
        <Gutter bottom="16px" />
        <ReadonlyTextarea
          name="commitment"
          value={texts.resourcesText}
          formatting="modern"
        />
      </AccordionsItemSection>
    </AccordionsItem>
  );
};
